<app-header-espace-client [email]="userEmail"></app-header-espace-client>

<main class="main-content">
  <div class="container">
    <!-- Section de recherche de conversion -->
    <div class="row justify-content-center mb-2">
      <div class="col-lg-8">
        <div class="search-card">
          <div class="search-header">
            <div class="search-icon">
              <i class="fas fa-file-upload"></i>
            </div>
            <h2 class="search-title">Nouvelle conversion PDF vers Word</h2>
            <p class="search-subtitle">Convertissez vos fichiers PDF en documents Word modifiables</p>
          </div>
          
          <div class="upload-container">
            <div class="upload-box" 
                 [class]="dragOverClass"
                 (dragover)="onDragOver($event)"
                 (dragleave)="onDragLeave($event)"
                 (drop)="onDrop($event)"
                 (click)="triggerFileInput()">
              <i class="fas fa-file-upload upload-icon"></i>
              <p class="upload-text">Glissez-déposez un PDF ou cliquez pour en sélectionner un</p>
              
              <!-- Affichage du fichier sélectionné -->
              <div *ngIf="selectedFile" class="selected-file">
                <div class="file-info">
                  <i class="file-icon">📄</i>
                  <span class="file-name">{{ selectedFile.name }}</span>
                  <span class="file-size">({{ selectedFile ? (selectedFile.size / 1024 / 1024).toFixed(2) : '0' }} MB)</span>
                </div>
                
                <!-- Bouton de conversion avec états multiples -->
                <button 
                  type="button" 
                  class="btn btn-success convert-btn" 
                  [disabled]="isUploading || isConverting || isSavingToDatabase"
                  (click)="startConversion(); $event.stopPropagation()">
                  
                  <!-- État normal -->
                  <span *ngIf="!isUploading && !isConverting && !isSavingToDatabase">
                    CONVERTIR EN WORD
                  </span>
                  
                  <!-- État upload -->
                  <span *ngIf="isUploading">
                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    UPLOAD EN COURS...
                  </span>
                  
                  <!-- État conversion -->
                  <span *ngIf="isConverting">
                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    CONVERSION EN COURS...
                  </span>
                  
                  <!-- État sauvegarde -->
                  <span *ngIf="isSavingToDatabase">
                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    SAUVEGARDE...
                  </span>
                </button>
              </div>
            </div>
            
            <!-- Input file caché -->
            <input 
              type="file" 
              id="fileInput" 
              accept=".pdf,application/pdf" 
              (change)="onFileSelected($event)"
              style="display: none;">
          </div>
          
          <!-- Section de progression détaillée -->
          <div *ngIf="isUploading || isConverting || isSavingToDatabase" class="progress-section mt-3">
            <div class="progress-container">
              <!-- Progression Upload -->
              <div *ngIf="isUploading" class="progress-step">
                <div class="progress-header">
                  <i class="fas fa-upload text-primary me-2"></i>
                  <span class="progress-title">Upload du fichier</span>
                  <span class="progress-percentage">{{ Math.round(uploadProgress) }}%</span>
                </div>
                <div class="progress-bar-container">
                  <div class="progress-bar" [style.width.%]="uploadProgress"></div>
                </div>
                <div class="progress-message">{{ uploadMessage }}</div>
              </div>
              
              <!-- Progression Conversion -->
              <div *ngIf="isConverting" class="progress-step">
                <div class="progress-header">
                  <i class="fas fa-cogs me-2"></i>
                  <span class="progress-title">Conversion PDF vers Word</span>
                  <span class="progress-percentage">{{ Math.round(conversionProgress) }}%</span>
                </div>
                <div class="progress-bar-container">
                  <div class="progress-bar conversion-bar" [style.width.%]="conversionProgress"></div>
                </div>
                <div class="progress-message">{{ conversionMessage }}</div>
              </div>
              
              <!-- Progression Sauvegarde -->
              <div *ngIf="isSavingToDatabase" class="progress-step">
                <div class="progress-header">
                  <i class="fas fa-save text-success me-2"></i>
                  <span class="progress-title">Sauvegarde en base de données</span>
                  <span class="progress-percentage">100%</span>
                </div>
                <div class="progress-bar-container">
                  <div class="progress-bar save-bar" style="width: 100%"></div>
                </div>
                <div class="progress-message">{{ saveMessage }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section des conversions -->
    <div class="row justify-content-center mb-5">
      <div class="col-lg-8">
        <div class="conversions-card">
          <div class="conversions-header row">
            <div class="col-12 col-md-9">
              <h2 class="conversions-title">Vos conversions</h2>
              <p class="conversions-subtitle">Gérez vos fichiers convertis et en cours de traitement</p>
            </div>
            <div class="col-12 col-md-3">
              <button 
                class="btn btn-outline-primary btn-sm refresh-btn w-75" 
                (click)="refreshFiles()" 
                [disabled]="isLoadingFiles">
                <i class="fas fa-sync-alt" [class.fa-spin]="isLoadingFiles"></i>
                {{ isLoadingFiles ? 'Chargement...' : 'Actualiser' }}
              </button>
            </div>
          </div>
          
          <!-- Section de chargement -->
          <div *ngIf="isLoadingFiles" class="loading-section">
            <div class="text-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Chargement...</span>
              </div>
              <p class="mt-2">Chargement de vos fichiers...</p>
            </div>
          </div>

          <!-- Section d'erreur -->
          <div *ngIf="filesError && !isLoadingFiles" class="error-section">
            <div class="alert alert-danger" role="alert">
              <i class="fas fa-exclamation-triangle me-2"></i>
              {{ filesError }}
              <button class="btn btn-outline-danger btn-sm ms-2" (click)="refreshFiles()">
                Réessayer
              </button>
            </div>
          </div>

          <!-- Liste des fichiers -->
          <div *ngIf="!isLoadingFiles && !filesError" class="conversions-list">
            <!-- Message si aucun fichier -->
            <div *ngIf="clientFiles.length === 0" class="no-files-message">
              <div class="text-center py-4">
                <i class="fas fa-file-upload fa-3x text-muted mb-3"></i>
                <h4 class="text-muted">Aucun fichier converti</h4>
                <p class="text-muted">Commencez par convertir votre premier PDF en document Word</p>
              </div>
            </div>

            <!-- Liste des fichiers -->
            <div *ngFor="let file of clientFiles" class="conversion-item">
              <div class="conversion-icon">
                <i class="fas fa-file-word text-primary"></i>
              </div>
              <div class="conversion-info">
                <h4 class="conversion-name">{{ getFileNameWithoutExtension(file.filename) }}</h4>
                <p class="conversion-status">
                  <i class="fas fa-calendar-alt me-1"></i>
                  Converti le {{ formatDate(file.created_at) }}
                </p>
              </div>
              <div class="conversion-actions">
                <button 
                  class="btn btn-outline-primary btn-sm" 
                  (click)="downloadFile(file)"
                  title="Télécharger le fichier">
                  <i class="fas fa-download me-1"></i>
                  Télécharger
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section d'aide -->
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <div class="help-card">
          <div class="help-header">
            <div class="help-icon">
              <i class="fas fa-question-circle"></i>
            </div>
            <h3 class="help-title">Besoin d'aide ?</h3>
          </div>
          <div class="help-content">
            <p class="help-text">
              Si vous rencontrez des difficultés avec la conversion de vos fichiers, notre équipe peut vous aider. 
              Contactez-nous à <a href="mailto:{{ supportEmail }}" class="help-link">{{ supportEmail }}</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<app-footer></app-footer>
